import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, ArrowLeft, MailCheck } from 'lucide-react';
import { GabryxFooter } from '../components/GabryxBranding';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Une erreur est survenue. Réessayez plus tard.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[#111827]">CHANTIX</h1>
            <p className="text-sm text-[#6B7280] mt-1">Mot de passe oublié</p>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-[#E5E7EB] p-6 sm:p-8">
            {!sent ? (
              <>
                <p className="text-sm text-[#4B5563] mb-5">
                  Saisissez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
                </p>
                <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
                  <div>
                    <Label htmlFor="email">Adresse email</Label>
                    <Input id="email" type="email" required value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="vous@exemple.fr"
                      className="mt-1" data-testid="forgot-email-input" />
                  </div>
                  {error && (
                    <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2"
                      data-testid="forgot-error">{error}</div>
                  )}
                  <Button type="submit" disabled={loading}
                    className="w-full bg-[#0055FF] hover:bg-blue-700"
                    data-testid="forgot-submit-btn">
                    {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Envoi...</> : 'Envoyer le lien'}
                  </Button>
                </form>
              </>
            ) : (
              <div className="text-center py-4" data-testid="forgot-success">
                <MailCheck size={48} className="text-emerald-500 mx-auto mb-3" />
                <h2 className="text-lg font-semibold text-[#111827] mb-2">Vérifiez votre email</h2>
                <p className="text-sm text-[#4B5563]">
                  Si <span className="font-semibold">{email}</span> est associé à un compte, vous recevrez sous quelques instants un email contenant un lien pour réinitialiser votre mot de passe.
                </p>
                <p className="text-xs text-[#6B7280] mt-3">Le lien expire dans 1 heure.</p>
              </div>
            )}

            <div className="mt-6 text-center text-sm">
              <Link to="/login" className="text-[#0055FF] hover:underline inline-flex items-center gap-1"
                data-testid="back-to-login">
                <ArrowLeft size={14} /> Retour à la connexion
              </Link>
            </div>
          </div>
        </div>
      </div>
      <GabryxFooter />
    </div>
  );
}

export default ForgotPasswordPage;
